(() => {
  const init = () => {
    document.documentElement.classList.add('ob-js');

    const header = document.querySelector('#header-component');
    const updateHeader = () => header?.classList.toggle('ob-header-scrolled', window.scrollY > 20);
    updateHeader();
    window.addEventListener('scroll', updateHeader, { passive: true });

    const targets = document.querySelectorAll('[data-ob-reveal]:not([data-ob-reveal] [data-ob-reveal])');
    if (!('IntersectionObserver' in window) || window.matchMedia('(prefers-reduced-motion: reduce)').matches) {
      targets.forEach((target) => target.classList.add('is-visible'));
      return;
    }

    const observer = new IntersectionObserver((entries) => {
      entries.forEach((entry) => {
        if (!entry.isIntersecting) return;
        entry.target.classList.add('is-visible');
        observer.unobserve(entry.target);
      });
    }, { threshold: 0, rootMargin: '0px 0px 60px 0px' });

    targets.forEach((target) => {
      if (target.getBoundingClientRect().top < window.innerHeight) {
        target.classList.add('is-visible');
      } else {
        target.classList.add('ob-reveal');
      }
      observer.observe(target);
    });
  };

  document.addEventListener('click', (event) => {
    const control = event.target.closest('[data-ob-flip]');
    if (!control) return;
    const card = control.closest('.ob-card');
    const isBack = card.classList.toggle('is-back');
    control.setAttribute('aria-pressed', String(isBack));
    control.textContent = isBack ? 'Ön yüzü göster' : 'Arka yüzü göster';
  });

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init, { once: true });
  } else {
    init();
  }
})();
